import React, { useCallback } from 'react';

import { FormikHelpers } from 'formik';

import { TypesList, Type } from './styles';

export interface Option {
  label: string;
  value: any;
  icon: string;
}

interface Props {
  name?: string;
  value?: any;
  options?: Option[];
  formik?: FormikHelpers<string>;
}

const Types = ({ name, value, options, formik }: Props) => {
  const isSelected = useCallback((currentValue: any) => value === currentValue, [value]);

  const handleClick = async (newValue: any) => {
    if (formik && name && newValue !== value) {
      await formik.setFieldValue(name, newValue);
      formik.setFieldTouched(name);
    }
  };

  return (
    <TypesList>
      {options?.map((option) => (
        <Type
          key={option.value}
          className={isSelected(option.value) ? 'active' : ''}
          onClick={() => handleClick(option.value)}
        >
          <Type.Icon isActive={isSelected(option.value)} src={`/images/expense-types/${option.icon}.svg`} />
          <Type.Label>{option.label}</Type.Label>
        </Type>
      ))}
    </TypesList>
  );
};

export default Types;
